<template>
  <!-- La chat con il medico non è attiva per il cittadino: una frase con il
       numero verde e «Richiedi il servizio», bottone pieno che chiama.
       L'allineamento lo decide chi lo usa (.empty-state al centro, .tint-box
       a sinistra). La stessa cosa c'è nell'app. -->
  <div>
    <p class="mb-3">{{ $t("RichiediServizioChat.testo", { numero: $t("numero_supporto") }) }}</p>
    <b-button
      variant="primary"
      :href="telefono"
      :aria-label="$t('RichiediServizioChat.aria', { numero: $t('numero_supporto') })"
    >
      <b-icon icon="telephone-fill" class="mr-2" aria-hidden="true"></b-icon>
      {{ $t("RichiediServizioChat.bottone") }}
    </b-button>
  </div>
</template>

<script>
// Il numero è quello della chiave numero_supporto (800.770.272): il link
// tel: ne tiene le sole cifre, così il numero sta in un posto solo
export default {
  name: "RichiediServizioChat",
  computed: {
    telefono() {
      return "tel:" + String(this.$t("numero_supporto")).replace(/\D/g, "");
    },
  },
};
</script>
